import { QRCode } from 'react-qr-code'
import { Close, OpenInNew } from '@mui/icons-material'
import { Dialog, DialogContent, Grid, IconButton, Typography, useTheme } from '@mui/material'

import { BRANCH_ENV, BRANCH_URL } from '../../../../utils/constants'
import useSharedStyles from '../../../../utils/shared.styles'
import useStyles from '../../index.styles'

const ProtectMobileDialog = ({ folderId, open, setOpen }: { folderId: number; open: boolean; setOpen: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()

  return (
    <Dialog onClose={() => setOpen(false)} open={open}>
      <DialogContent>
        <Grid container={true} sx={[sharedClasses.centerContentVertical, { justifyContent: 'space-between' }]}>
          <Typography variant="h6">View in Protect Mobile</Typography>
          <IconButton onClick={() => setOpen(false)} aria-label="Close dialog">
            <Close color="action" />
          </IconButton>
        </Grid>
      </DialogContent>
      <DialogContent dividers>
        <Grid container={true} sx={[sharedClasses.centerContentVertical, { flexDirection: 'column' }]}>
          <Typography variant="body1">Scan QR code with your mobile device's camera</Typography>
          <QRCode value={`${BRANCH_URL}${BRANCH_ENV}/view-account?id=${folderId}`} size={144} level="M" style={classes.qrcode(theme)} />
          <Typography
            variant="body1"
            sx={classes.qrcodeLink}
            component="a"
            href={`${BRANCH_URL}${BRANCH_ENV}/view-account?id=${folderId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Or select the link here
            <OpenInNew fontSize="small" sx={classes.leftSpaceIcon} />
          </Typography>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ProtectMobileDialog
